import vue2Dropzone from "vue2-dropzone";
import vSelect from "vue-select";
import Vue from "vue";
import tooltip from "vue-bulma-tooltip";
import { Modal } from "vue-bulma-modal";
import draggable from "vuedraggable";
import flatPickr from "vue-flatpickr-component";
import "cleave.js/dist/addons/cleave-phone.cn";
import "flatpickr/dist/flatpickr.css";
import Cleave2 from "vue-cleave-component";

export function init() {
  Vue.component("Pagination", require("./Pagination").default);
  Vue.component("VSelect", vSelect);
  Vue.component("VueDropzone", vue2Dropzone);
  Vue.component("Quill", require("vue-bulma-quill").default);
  Vue.component("VbSwitch", require("vue-bulma-switch").default);
  Vue.component("Tooltip", tooltip);
  Vue.component("Modal", Modal);
  Vue.component("Draggable1", draggable);
  Vue.component("EditButton", require("./buttons/EditButton").default);
  Vue.component("DeleteButton", require("./buttons/DeleteButton").default);
  Vue.component("AddButton", require("./buttons/AddButton").default);
  Vue.component("SaveButton", require("./buttons/SaveButton").default);
  Vue.component("CancelButton", require("./buttons/CancelButton").default);
  Vue.component("ResetButton", require("./buttons/ResetButton").default);
  Vue.component("PauseButton", require("./buttons/PauseButton").default);
  Vue.component("Cleave2", Cleave2);
  Vue.use("cleave2", Cleave2);
  Vue.component("FlatPickr", flatPickr);
  Vue.component("VcSwitch", require("./buttons/switch").default);
  Vue.component("ShipperForm", require("../shippers/form").default);
  Vue.component("WarehouseForm", require("../warehouses/form").default);
  Vue.component("SupplierForm", require("../supplier/form").default);
  Vue.component("AreaForm", require("../machines/area/form").default);
  Vue.component("AccountForm", require("../admin/account/form").default);
  Vue.component("RoleForm", require("../admin/role/form").default);
  Vue.component("ProfileForm", require("../profile/form").default);
  Vue.component(
    "BannerDropzone",
    require("../post/category/dropzone").default
  );
  Vue.component("PostDropzone", require("../post/dropzone").default);
  Vue.component("WalaDropzone", require("./dropzone/wala-dropzone").default);
  Vue.component(
    "BirthdayDropzone",
    require("../birthday_mail/dropzone").default
  );
  Vue.component(
    "TimeslotEditModal",
    require("../shipping/timeslot/EditModal").default
  );
  Vue.component("SliderForm", require("../setting/appearance/slider/form").default);
  Vue.component("PostCatForm", require("../post/category/form").default);
  Vue.component("PlanForm", require("../plan/form").default);
  Vue.component("CustomerForm", require("../customer/form").default);
  Vue.component("VcQuill", require("./quill/quillcustom").default);
}
Vue.component(
  "SearchProduct",
  require("views/components/search/SearchProduct").default
);
Vue.component(
  "SearchCustomer",
  require("views/components/search/SearchCustomer").default
);
Vue.component(
  "SearchSupplier",
  require("views/components/search/SearchSupplier").default
);
Vue.component(
  "SearchOffer",
  require("views/components/search/SearchOffer").default
);
Vue.component(
  "SearchWinemag",
  require("views/components/search/SearchWinemag").default
);
